// extracted by mini-css-extract-plugin
export default {"rating":"wI-z","numberOfStars":"xI-z","count":"yI-z","barGraphSpacing":"zI-z","barGraph":"AI-z"};